<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" class="pa-2">
        <ListActivitesOverview></ListActivitesOverview>
      </v-col>
      <v-col cols="12" md="6" class="pa-2">
        <GraphActivitesPerWeek></GraphActivitesPerWeek>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GraphActivitesPerWeek from "./GraphActivitesPerWeek.vue";
import ListActivitesOverview from "./ListActivitesOverview.vue";

export default {
  components: { GraphActivitesPerWeek, ListActivitesOverview },
};
</script>

<style lang="scss" scoped>
</style>